<style scoped>
.expand-row {
  margin-bottom: 16px;
}
</style>
<template>
  <div>
    <List item-layout="vertical">
      <ListItem v-for="item in row"
                :key="item.pay_order_num">
        <!--<ListItemMeta :avatar="item.good_thumb" :title="item.good_title" :description="item.good_spec_name" class="listTitle" />-->
        <ListItemMeta :title="item.pay_order_num"
                      class="listTitle" />
        <template slot="action">
          <li v-if="item.type == 1">付款类型: 定金</li>
          <li v-else>付款类型: 尾款</li>
          <li>金额:{{ item.total_prices }}元</li>
          <li v-if="item.pay_status == 1">支付状态:支付中</li>
          <li v-else-if="item.pay_status == 0">支付状态:待支付</li>
          <li v-else>支付状态:支付成功</li>
          <li>支付方式:{{ item.pay_name }}</li>
        </template>
      </ListItem>
    </List>
    <!--<Table border :columns="list" :data="row" ></Table>-->
  </div>
</template>
<script>
export default {
  props: {
    row: Array
  }
  // data() {
  //     return {
  //         list: [
  //             {
  //                 title: "产品名称",
  //                 key: "good_title",
  //                 align: "center",
  //                 expand: true
  //             },
  //             {
  //                 title: "产品规格",
  //                 width: 100,
  //                 key: "good_spec_name",
  //                 align: "center"
  //             },
  //             {
  //                 title: "数量",
  //                 width: 70,
  //                 key: "nums",
  //                 align: "center",
  //             },
  //             {
  //                 title: "单价（元）",
  //                 width: 120,
  //                 key: "price",
  //                 align: "center",
  //             },
  //             {
  //                 title: "总价（元）",
  //                 width: 120,
  //                 key: "total_prices",
  //                 align: "center",
  //             },
  //             {
  //                 title: '状态',
  //                 align: "center",
  //                 key: 'status',
  //                 width: 80,
  //                 render: (h, params) => {
  //                     return h('div', params.row.status == 1 ? '退回' : '正常')
  //                 }
  //             }
  //         ]
  //     }
  // }
};
</script>
<style>
</style>